/* PufyCloud Soft – theme.js */
(() => {
  'use strict';
  const T = window.theme || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const cartUrl = T.cartUrl || '/cart';

  const esc = (v) => String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- para biçimi (Shopify money_format ile uyumlu) ---------- */
  const group = (n, thousand, decimal, digits) => {
    const fixed = (n / 100).toFixed(digits);
    const [whole, frac] = fixed.split('.');
    return whole.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousand) + (frac ? decimal + frac : '');
  };
  const money = (cents) => {
    const format = T.moneyFormat || ('{' + '{amount}}');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, name) => {
      switch (name) {
        case 'amount_no_decimals': return group(cents, ',', '.', 0);
        case 'amount_with_comma_separator': return group(cents, '.', ',', 2);
        case 'amount_no_decimals_with_comma_separator': return group(cents, '.', ',', 0);
        case 'amount_with_apostrophe_separator': return group(cents, "'", '.', 2);
        case 'amount_no_decimals_with_space_separator': return group(cents, ' ', '.', 0);
        case 'amount_with_space_separator': return group(cents, ' ', ',', 2);
        default: return group(cents, ',', '.', 2);
      }
    });
  };

  /* ---------- bildirim ---------- */
  const toastEl = $('#toast');
  let toastTimer;
  const toast = (msg) => {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('show'), 2800);
  };

  /* ---------- sepet ---------- */
  const drawer = $('#cartDrawer');
  const body = drawer && $('[data-cart-body]', drawer);
  const foot = drawer && $('[data-cart-foot]', drawer);
  const statusEl = drawer && $('[data-cart-status]', drawer);
  let lastTrigger = null;

  const setStatus = (msg, isError) => {
    if (!statusEl) return;
    statusEl.textContent = msg || '';
    statusEl.classList.toggle('is-error', !!isError);
  };
  const sized = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');

  const renderCart = (cart) => {
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    updateFreeShip(cart.total_price);
    if (!drawer) return;
    $('[data-cart-count-text]', drawer).textContent = cart.item_count + ' ürün';
    $('[data-cart-subtotal]', drawer).innerHTML = money(cart.total_price);
    if (!cart.items.length) {
      body.innerHTML = '<div class="drawer-empty"><h3>Sepetin henüz boş.</h3><p>Rengini seçip konforu sepete ekleyebilirsin.</p><a class="button" href="' + esc(T.allProductsUrl || '/') + '">Alışverişe başla</a></div>';
      foot.classList.add('is-empty');
      return;
    }
    foot.classList.remove('is-empty');
    body.innerHTML = cart.items.map((item) => {
      const img = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p>' + esc(item.variant_title) + '</p>' : '';
      return '<article class="drawer-line">' +
        '<a class="drawer-line-img" href="' + esc(item.url) + '">' + (img ? '<img src="' + esc(sized(img, 240)) + '" alt="' + esc(item.product_title) + '" width="78" height="97" loading="lazy">' : '') + '</a>' +
        '<div><a href="' + esc(item.url) + '"><h3>' + esc(item.product_title) + '</h3></a>' + variant +
        '<strong>' + money(item.final_line_price) + '</strong>' +
        '<div class="drawer-qty">' +
        '<button type="button" data-line="' + esc(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Adedi azalt">&minus;</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-line="' + esc(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Adedi artır">+</button>' +
        '<button type="button" class="remove" data-line="' + esc(item.key) + '" data-qty="0">Kaldır</button>' +
        '</div></div></article>';
    }).join('');
  };

  const fetchCart = async () => {
    const res = await fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('cart');
    const cart = await res.json();
    renderCart(cart);
    return cart;
  };

  const openDrawer = async (trigger) => {
    if (!drawer) return;
    lastTrigger = trigger || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    $('.cart-drawer-close', drawer).focus();
    try { await fetchCart(); } catch (_) { setStatus('Sepet yüklenemedi. Sayfayı yenilemeyi dene.', true); }
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  };

  if (drawer) {
    drawer.addEventListener('click', async (e) => {
      if (e.target.closest('[data-cart-close]')) return closeDrawer();
      const btn = e.target.closest('[data-line]');
      if (!btn) return;
      btn.disabled = true;
      setStatus('Sepet güncelleniyor…');
      try {
        const res = await fetch(cartUrl + '/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: btn.dataset.line, quantity: Number(btn.dataset.qty) })
        });
        if (!res.ok) throw new Error('change');
        renderCart(await res.json());
        setStatus('');
      } catch (_) {
        setStatus('Sepet güncellenemedi. Lütfen tekrar dene.', true);
        btn.disabled = false;
      }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
  }

  // Üst menüdeki sepet düğmesi (JS yoksa normal sepet sayfasına gider)
  $$('[data-cart-open]').forEach((el) => el.addEventListener('click', (e) => {
    if (!T.cartDrawer || !drawer || document.body.classList.contains('template-cart')) return;
    e.preventDefault();
    openDrawer(el);
  }));

  /* ---------- ücretsiz kargo çubuğu ---------- */
  function updateFreeShip(total) {
    $$('[data-free-ship]').forEach((el) => {
      const thr = Number(el.dataset.threshold || 0);
      const left = thr - total;
      const text = $('[data-free-ship-text]', el);
      const fill = $('[data-free-ship-fill]', el);
      if (text) text.innerHTML = left > 0 ? (el.dataset.text || '').replace('[kalan]', money(left)) : (el.dataset.done || '');
      if (fill) fill.style.width = (thr > 0 ? Math.min(100, Math.round((total * 100) / thr)) : 0) + '%';
    });
  }

  /* ---------- geri sayım ---------- */
  const pad = (n) => String(Math.max(0, n)).padStart(2, '0');
  const initCountdown = (el) => {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    const mode = el.dataset.mode;
    const target = () => {
      if (mode === 'fixed') {
        const raw = (el.dataset.end || '').trim().replace(' ', 'T');
        const t = new Date(raw);
        return isNaN(t) ? null : t.getTime();
      }
      const d = new Date();
      d.setHours(24, 0, 0, 0);
      return d.getTime();
    };
    const tick = () => {
      const end = target();
      if (end === null) { el.hidden = true; return; }
      let diff = Math.floor((end - Date.now()) / 1000);
      if (diff <= 0) {
        clearInterval(timer);
        if (el.dataset.expired === 'message') el.innerHTML = '<span class="cd-label">' + esc(el.dataset.expiredText) + '</span>';
        else el.hidden = true;
        return;
      }
      const showDays = !!$('[data-cd="d"]', el);
      const d = Math.floor(diff / 86400);
      if (showDays) diff -= d * 86400;
      const h = Math.floor(diff / 3600); diff -= h * 3600;
      const m = Math.floor(diff / 60);
      const sec = diff - m * 60;
      const set = (k, v) => { const n = $('[data-cd="' + k + '"]', el); if (n) n.textContent = pad(v); };
      set('d', d); set('h', h); set('m', m); set('s', sec);
    };
    const timer = setInterval(tick, 1000);
    tick();
  };

  /* ---------- ürün bölümü ---------- */
  const initProduct = (section) => {
    const jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    let product;
    try { product = JSON.parse(jsonEl.textContent); } catch (_) { return; }
    let inventory = {};
    try { inventory = JSON.parse($('[data-inventory-json]', section).textContent); } catch (_) { /* yok */ }

    const form = $('form.buy-form', section);
    const idInput = form && $('[data-variant-id]', form);
    const qtyInput = form && $('[data-quantity]', form);
    const addBtn = form && $('[data-add-btn]', form);
    const addLabel = addBtn && $('[data-add-label]', addBtn);
    const errEl = form && $('[data-form-error]', form);
    const mobileBar = $('[data-mobile-buy]', section);
    const mobilePrice = $('[data-price-mobile]', section);
    const mobileAdd = $('[data-mobile-add]', section);
    const mobileLabel = $('[data-mobile-label]', section);
    const fieldsets = $$('.option', section);
    const bundleInputs = $$('input[name="bundle"]', section);
    const qtyControl = $('[data-qty-input]', section);
    const soldOutText = addBtn ? addBtn.dataset.soldout || 'Tükendi' : 'Tükendi';
    const defaultLabel = addLabel ? addLabel.textContent.trim() : 'Sepete ekle';
    const stickyOn = !!(addBtn && addBtn.dataset.sticky === 'true');

    if (bundleInputs.length && !bundleInputs.some((b) => b.checked)) bundleInputs[0].checked = true;

    const selectedValues = () => fieldsets.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
    const findVariant = () => {
      if (!fieldsets.length) return product.variants[0];
      const sel = selectedValues();
      return product.variants.find((v) => sel.every((val, i) => [v.option1, v.option2, v.option3][i] === val));
    };
    const currentQty = () => {
      const bundle = bundleInputs.find((b) => b.checked);
      if (bundle) return Math.max(1, Number(bundle.value) || 1);
      if (qtyControl) return Math.max(1, Number(qtyControl.value) || 1);
      return 1;
    };

    const setGallery = (mediaId) => {
      if (mediaId == null) return;
      const id = String(mediaId);
      const slides = $$('.gallery-slide', section);
      if (!slides.some((s) => s.dataset.mediaId === id)) return;
      slides.forEach((s) => s.classList.toggle('is-active', s.dataset.mediaId === id));
      $$('.gallery-thumb', section).forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === id));
    };

    const update = (event) => {
      fieldsets.forEach((fs) => { const c = $('input:checked', fs); const l = $('[data-option-label]', fs); if (c && l) l.textContent = c.value; });
      const variant = findVariant();
      const qty = currentQty();
      if (qtyInput) qtyInput.value = qty;
      if (errEl) errEl.hidden = true;

      let disabled = true;
      let label = 'Mevcut değil';
      if (variant) {
        if (idInput) idInput.value = variant.id;
        $$('[data-price]', section).forEach((el) => { el.innerHTML = money(variant.price); });
        if (mobilePrice) mobilePrice.innerHTML = money(variant.price);
        const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        $$('[data-compare-price]', section).forEach((el) => { el.hidden = !hasCompare; if (hasCompare) el.innerHTML = money(variant.compare_at_price); });
        $$('[data-bundle-price]', section).forEach((el) => { el.innerHTML = money(variant.price * Number(el.dataset.qty || 1)); });
        // indirim rozeti
        $$('[data-savings]', section).forEach((el) => {
          el.hidden = !hasCompare;
          if (hasCompare) {
            const pct = Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
            $('[data-savings-text]', el).innerHTML = (el.dataset.text || '').replace('[yuzde]', pct).replace('[tutar]', money(variant.compare_at_price - variant.price));
          }
        });
        // stok uyarısı
        const inv = inventory[variant.id] || { q: 0, m: false };
        $$('[data-stock-block]', section).forEach((el) => {
          const th = Number(el.dataset.threshold || 0);
          const show = el.dataset.mode === 'always' || (inv.m && inv.q > 0 && inv.q <= th);
          el.hidden = !show;
          const t = $('[data-stock-text]', el);
          if (t) t.textContent = (el.dataset.text || '').replace('[adet]', inv.q);
          const f = $('[data-stock-fill]', el);
          if (f) f.style.width = (th > 0 && inv.q > 0 ? Math.min(100, Math.round((inv.q * 100) / th)) : 100) + '%';
        });
        // ürün bilgi satırları
        $$('[data-meta-sku]', section).forEach((el) => { el.textContent = variant.sku || '-'; });
        $$('[data-meta-avail]', section).forEach((el) => {
          el.textContent = variant.available ? el.dataset.in : el.dataset.out;
          el.classList.toggle('is-in', !!variant.available);
          el.classList.toggle('is-out', !variant.available);
        });
        disabled = !variant.available;
        label = variant.available ? defaultLabel : soldOutText;
        if (variant.featured_media) setGallery(variant.featured_media.id);
        if (event && event.type === 'change' && fieldsets.length) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }
      if (addBtn) addBtn.disabled = disabled;
      if (addLabel) addLabel.textContent = label;
      if (mobileAdd) mobileAdd.disabled = disabled;
      if (mobileLabel) mobileLabel.textContent = label;
    };

    fieldsets.forEach((fs) => fs.addEventListener('change', update));
    bundleInputs.forEach((b) => b.addEventListener('change', update));
    $$('.gallery-thumb', section).forEach((t) => t.addEventListener('click', () => setGallery(t.dataset.thumb)));

    // adet seçici
    if (qtyControl) {
      $$('[data-qty-step]', section).forEach((btn) => btn.addEventListener('click', () => {
        const max = Number(qtyControl.max) || 99;
        qtyControl.value = Math.min(max, Math.max(1, (Number(qtyControl.value) || 1) + Number(btn.dataset.qtyStep)));
        update({ type: 'qty' });
      }));
      qtyControl.addEventListener('change', () => update({ type: 'qty' }));
    }

    if (form && addBtn) {
      form.addEventListener('submit', async (e) => {
        if (!T.cartDrawer) return; // normal form gönderimi
        e.preventDefault();
        if (addBtn.disabled) return;
        addBtn.disabled = true;
        errEl.hidden = true;
        const data = new FormData();
        data.append('id', idInput.value);
        data.append('quantity', qtyInput.value);
        try {
          const res = await fetch(cartUrl + '/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
          const json = await res.json();
          if (!res.ok) throw new Error(json.description || json.message || 'add');
          await openDrawer(addBtn);
          toast('Ürün sepete eklendi.');
        } catch (err) {
          errEl.textContent = err.message && err.message !== 'add' ? err.message : 'Ürün sepete eklenemedi. Seçimlerini ve stok durumunu kontrol et.';
          errEl.hidden = false;
        } finally {
          const v = findVariant();
          addBtn.disabled = !(v && v.available);
        }
      });
      if (mobileAdd) mobileAdd.addEventListener('click', () => form.requestSubmit(addBtn));
      if (mobileBar && stickyOn && 'IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => mobileBar.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 }).observe(addBtn);
      }
    }
    update();
  };

  /* ---------- kaydırıcı okları ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-carousel-prev],[data-carousel-next]');
    if (!btn) return;
    const root = btn.closest('[data-carousel]');
    const track = root && $('[data-carousel-track]', root);
    if (!track) return;
    const step = (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width : 300) + 16;
    track.scrollBy({ left: btn.hasAttribute('data-carousel-next') ? step : -step, behavior: 'smooth' });
  });

  /* ---------- açılır pencere, kopyala, geri sayım ---------- */
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-popup-open]');
    if (open) {
      const dlg = document.getElementById(open.dataset.popupOpen);
      if (dlg && dlg.showModal) dlg.showModal();
      return;
    }
    const close = e.target.closest('[data-popup-close]');
    if (close) { const dlg = close.closest('dialog'); if (dlg) dlg.close(); return; }
    if (e.target.matches('dialog.popup')) { e.target.close(); return; }
    const copy = e.target.closest('[data-copy-link]');
    if (copy) {
      const link = copy.dataset.copyLink || window.location.href;
      (navigator.clipboard ? navigator.clipboard.writeText(link) : Promise.reject()).then(() => toast(copy.dataset.copyMsg || 'Bağlantı kopyalandı.')).catch(() => toast(link));
    }
  });

  /* ---------- duyuru çubuğu (dönen mesajlar) ---------- */
  const initAnnounce = (el) => {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    const msgs = $$('.announce-msg', el);
    if (msgs.length < 2) return;
    let i = 0;
    const speed = Math.max(2, Number(el.dataset.speed) || 4) * 1000;
    setInterval(() => {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, speed);
  };

  /* ---------- detay noktaları ---------- */
  const initHotspots = (sec) => {
    if (sec.dataset.ready) return;
    sec.dataset.ready = '1';
    const dots = $$('.hs-dot', sec);
    const items = $$('.hs-item', sec);
    const activate = (n) => {
      dots.forEach((d, k) => d.classList.toggle('is-active', k === n));
      items.forEach((it, k) => it.classList.toggle('is-active', k === n));
    };
    dots.forEach((d, k) => d.addEventListener('click', () => activate(d.classList.contains('is-active') ? -1 : k)));
    items.forEach((it, k) => {
      it.addEventListener('mouseenter', () => activate(k));
      it.addEventListener('click', () => activate(k));
    });
  };

  /* ---------- kaydırınca belirme ---------- */
  const initReveal = () => {
    if (!document.body.classList.contains('has-reveal') || !('IntersectionObserver' in window)) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const targets = $$('#MainContent > .shopify-section').slice(1);
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    targets.forEach((t) => {
      const r = t.getBoundingClientRect();
      if (r.top < window.innerHeight) return; // ilk ekranda görünenler hemen görünsün
      t.classList.add('reveal');
      io.observe(t);
    });
  };

  /* ---------- kaydırınca üst bilgi gölgesi ---------- */
  const header = $('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  const initDynamic = (root) => {
    $$('[data-countdown]', root).forEach(initCountdown);
    $$('[data-announce]', root).forEach(initAnnounce);
    $$('.hs', root).forEach(initHotspots);
    if (root.matches && root.matches('.hs')) initHotspots(root);
  };
  initReveal();

  $$('[data-product-section]').forEach(initProduct);
  initDynamic(document);
  if ($('[data-free-ship]')) fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => updateFreeShip(c.total_price)).catch(() => {});
  document.addEventListener('shopify:section:load', (e) => {
    const s = e.target.matches('[data-product-section]') ? e.target : $('[data-product-section]', e.target);
    if (s) initProduct(s);
    initDynamic(e.target);
  });
})();
